module.exports = __webpack_public_path__ + "static/Deliver-Personalized-Experiences-41b86f40905125f305f7020d6207eb44.jpg";